import { createSelector } from 'reselect';

export const selectEmailTemplatesSlice = state => state.emailTemplates;

export const selectEmailTemplates = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.emailTemplates
);
export const emailTemplatesLoaded = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.emailTemplatesLoaded
);
export const selectActiveEmailTemplate = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.activeEmailTemplate
);

export const emailTemplatesMeta = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.meta
);
export const emailTemplatesFilters = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.filters
);

export const emailTemplateCreating = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.isCreating
);
export const emailTemplatesUpdating = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.isUpdating
);
export const emailTemplatesDeleting = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.isDeleting
);
export const emailTemplatesErrors = createSelector(
  selectEmailTemplatesSlice,
  slice => slice.errors
);
